import React, { Component } from 'react'
import CustomModal from './index';
import {ColorButton} from '../../../../index';
import Autoload from "../../../../Autoload";
import { Group, Stack } from '@mantine/core';
import { connect } from 'react-redux';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

class ReceiptAssigmentRemoveConfirmationForCpDeleteModal extends Component {
    state={
        success: null
    }
    constructor(props){
        super(props);
    }

    componentDidMount(){
     
    }
    render(){
        const {success} = this.state;
        const {open, toggle, className, type, history, removeReceipt} = this.props;
        console.log('type: ', type);
        return (
            <CustomModal 
            heading= {'Automatische Aktualisierung deaktivieren'}  
            open={open} 
            toggle={toggle} 
            className={`${className}`}>
                <Stack>
                    <Group>
                        <p className='mb-0' style={{fontWeight: '400'}}>Wenn Sie die Kostenposition löschen, wird die Eigenschaft "relevant für Betriebskostenabrechnung" der aktuell zugeordneten Belege deaktiviert.</p>
                        <p className='mb-0' style={{fontWeight: '400'}}>Wenn Sie Belege zukünftig wieder automatisiert berücksichtigen wollen, erstellen Sie die Kostenposition neu und fügen Sie die Belege manuell hinzu.</p>
                    </Group>
                    <Group justify="space-between" wrap="nowrap">
                        <div>
                            <ColorButton
                            text={'Abbrechen'}
                            className={'gray-btn'}
                            onClick={()=> toggle()}
                            />
                        </div>
                        <div>
                            <ColorButton
                            text={'Fortfahren'}
                            className={'purple-btn'}
                            onClick={()=> removeReceipt()}
                            />
                        </div>
                    </Group>
                </Stack>
            </CustomModal>
         )
    }
}
const mapStateToProps = (state) => {
    return {
        propertySelected: state.generalReducer.property,
        profile: state.generalReducer.profile,
        AccountApi: state.generalReducer.account_api_id,
    };
};

export default connect(mapStateToProps)(ReceiptAssigmentRemoveConfirmationForCpDeleteModal);
